import React, { memo, useMemo } from 'react';
import { css, type SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { sharedStyles, sharedFontStyle } from '../sharedStyles';

interface DivCssProps {
  sharedStyles: SerializedStyles;
  secondaryBtnBg: string;
}

interface SpanCssProps {
  sharedFontStyle: SerializedStyles;
  secondaryBtnTxt: string;
}

interface SolidSecondaryButtonProps {
  secondaryBtnBg: string;
  secondaryBtnTxt: string;
}

interface InsideDivProps {
  secondaryBtnTxt: string;
}

const Div = styled.div`
  ${({ sharedStyles, secondaryBtnBg }: DivCssProps) => css`
    ${sharedStyles};
    width: 40px;
    box-shadow: 0 0 3px #00000029;
    background-color: ${secondaryBtnBg};
  `}
`;
const Span = styled.span`
  ${({ sharedFontStyle, secondaryBtnTxt }: SpanCssProps) => css`
    ${sharedFontStyle};
    color: ${secondaryBtnTxt};
    position: relative;
  `}
`;

const insideDivsSharedStyles = css`
  position: absolute;
  color: black;
`;

const Line = styled.div`
  ${({ secondaryBtnTxt }: InsideDivProps) => css`
    ${insideDivsSharedStyles};
    color: ${secondaryBtnTxt};
    width: 20px;
    height: 20px;
    border-left: 2px solid;
    top: -10px;
    left: 0;
  `}
`;

const Arrow = styled.div`
  ${({ secondaryBtnTxt }: InsideDivProps) => css`
    ${insideDivsSharedStyles};
    color: ${secondaryBtnTxt};
    width: 12px;
    height: 12px;
    border-width: 0 2px 2px 0;
    border-style: solid;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    top: -4px;
    left: -5px;
  `}
`;

const SquareButton: React.FC<SolidSecondaryButtonProps> = ({
  secondaryBtnBg,
  secondaryBtnTxt,
}) => {
  const divCssProps = useMemo(
    () => ({
      sharedStyles,
      secondaryBtnBg,
    }),
    [secondaryBtnBg]
  );

  const spanCssProps = useMemo(
    () => ({
      sharedFontStyle,
      secondaryBtnTxt,
    }),
    [secondaryBtnTxt]
  );

  return (
    <Div {...divCssProps}>
      <Span {...spanCssProps}>
        <Line secondaryBtnTxt={secondaryBtnTxt} />
        <Arrow secondaryBtnTxt={secondaryBtnTxt} />
      </Span>
    </Div>
  );
};

export default memo(SquareButton);
